<ion-header [ngClass]="{'show-progress-bar-pad': deviceService.isBackgroundUploadInProgress }">
  <ind-header-left [hideFilterButton]="true" [searchText]="searchText" [viewData]="{title: 'SEARCH_SCHEDULER' | translate, controls: [], mode: true}"
    [searchDebounce]="300" (onSearchInput)="onSearchInput($event)"></ind-header-left>
  <ind-section-header [viewData]="routesHeaderModel"
    (onControlClick)='onSectionHeaderControlClick($event)'></ind-section-header>
</ion-header>
<ion-content *ngIf="schedulerList$ | async as schedulerList"
  [ngClass]="{'vectorimageleft': schedulerList.length === 0 && !searchText.length}">
  <ion-list>
    <scheduler-item *ngFor="let schedule of schedulerList; trackBy: trackByScheduleId" [schedule]="schedule" [isDeviceOnline]='isDeviceOnline'
      (onSelect)="onSelect($event)" [isSelected]="schedule?.ID === selectedSchedule?.ID"></scheduler-item>
    <div class="no-data-message" *ngIf="schedulerList.length === 0 && !searchText.length">
      {{'SCHEDULING_NO_ROUTES' | translate}}
    </div>
  </ion-list>
  <ion-infinite-scroll *ngIf="hasMoreData" (ionInfinite)="doInfinite($event.detail)" threshold="20%">
    <ion-infinite-scroll-content></ion-infinite-scroll-content>
  </ion-infinite-scroll>
  <ind-no-search-result *ngIf="schedulerList.length === 0 && searchText.length"
    [text]="('NO_RESULTS_FOR_THIS_SEARCH' | translate)"></ind-no-search-result>
</ion-content>
<footer-toolbar [footerView]="'masterView'" [selectedView]="'scheduler'"></footer-toolbar>
